$(document).on('turbolinks:load', function() {
  $('.content-moderation').on('click', '.remove-content, .remove-group-content', function(e) {
    e.preventDefault();
    $(this).parent().next('.remove-reason-overlay').removeClass('hidden');
  });
  $('.content-moderation').on('click', '.cancel-remove, .remove-reason-overlay .close', function(e) {
    e.preventDefault();
    $(this).closest('.remove-reason-overlay').addClass('hidden');
  });
  $('.content-moderation').on('click', '.submit-remove', function(e) {
    e.preventDefault();
    if(confirm('Are you sure you want to remove this content?')) {
      var entry = $(this).closest('.entry'),
        reason = $(this).closest('.remove-reason-overlay').find('textarea').val();
      $.ajax({
        url: '/system_admin/content_moderation/remove_content.js',
        type: 'POST',
        data: {
          'id': entry.data('id'),
          'type': entry.data('type'),
          'reason': reason,
        }
      });
    }
  });
  $('.content-moderation').on('click', '.undo-remove, .approve-content', function(e) {
      e.preventDefault();
      let confirm_message = $(this).parent().hasClass('submission') ?
        'Are you sure approve this video?' :
        'Are you sure you want to remove the flags on this content?';
      if(confirm(confirm_message)) {
         var entry = $(this).closest('.entry'),
          url = $(this).hasClass('undo-remove') ? '/system_admin/content_moderation/undo_remove_content.js' : '/system_admin/content_moderation/approve_content.js';
         $.ajax({
          url: url,
          type: 'POST',
          data: {
            'id': entry.data('id'),
            'type': entry.data('type'),
          }
        });
      }
  });

  $('.content-moderation').on('click', '.undo-remove, .image-approve-content', function(e) {
    e.preventDefault();
    let confirm_message = 'Are you sure approve this image?';
    if(confirm(confirm_message)) {
      const imageFlagged = $(this).closest('.image-flagged');
      const url = '/system_admin/content_moderation/flagged_user_images';
      $.ajax({
        url: url,
        type: 'POST',
        data: {
          'id': imageFlagged.data('id'),
          'type': imageFlagged.data('type'),
        }
      });
    }
  });

  $('.content-moderation').on('click', '.undo-remove, .image-remove-content', function(e) {
    e.preventDefault();
    $(this).parent().next('.image-remove-overlay').removeClass('hidden');
  });
  $('.content-moderation').on('click', '.image-cancel-remove, .remove-reason-overlay .close', function(e) {
    e.preventDefault();
    $(this).closest('.image-remove-overlay').addClass('hidden');
  });
  $('.content-moderation').on('click', '.image-submit-remove', function(e) {
    e.preventDefault();
    if(confirm('Are you sure you want to remove this content?')) {
      var entry = $(this).closest('.entry'),
          reason = $(this).closest('.remove-reason-overlay').find('textarea').val();
      var record_type = this.parentElement.parentElement.querySelector('.record_type').value;
      var record_id = this.parentElement.parentElement.querySelector('.record_id').value;
      $.ajax({
        url: '/system_admin/content_moderation/image_remove_content.js',
        type: 'POST',
        data: {
          'id': record_id,
          'type': record_type,
          'rejection_reason': reason,
        }
      });
    }
  });

  $('.content-moderation').on('click', '.approve-group-content', function(e) {
    e.preventDefault();
    let confirm_message = 'Are you sure approve this video?'
    if(confirm(confirm_message)) {
       var entry = $(this).closest('.entry'),
        url = '/system_admin/content_moderation/approve_group_content.js';
       $.ajax({
        url: url,
        type: 'POST',
        data: {
          'id': entry.data('id'),
          'type': entry.data('type'),
        }
      });
    }
});
$('.content-moderation').on('click', '.submit-remove-group', function(e) {
  e.preventDefault();
  if(confirm('Are you sure you want to remove this content?')) {
    var entry = $(this).closest('.entry'),
      reason = $(this).closest('.remove-reason-overlay').find('textarea').val();
    $.ajax({
      url: '/system_admin/content_moderation/remove_group_content.js',
      type: 'POST',
      data: {
        'id': entry.data('id'),
        'type': entry.data('type'),
        'reason': reason,
      }
    });
  }
});

  $('.content-moderation').on('click', '.override-rekognition', function(e) {
      e.preventDefault();
      if(confirm('Are you sure you want to override this rekognition flag?')) {
         var entry = $(this).closest('.entry'),
          url = '/system_admin/content_moderation/override_rekognition.js';
         $.ajax({
          url: url,
          type: 'POST',
          data: {
            'id': entry.data('id'),
            'type': entry.data('type'),
          }
        });
      }
  });

  $('.content-moderation').on('click', '.remove-rekognized', function(e) {
      e.preventDefault();
      if(confirm('Are you sure you want remove this video?')) {
         var entry = $(this).closest('.entry'),
          url = '/system_admin/content_moderation/remove_rekognized.js';
         $.ajax({
          url: url,
          type: 'POST',
          data: {
            'id': entry.data('id'),
            'type': entry.data('type'),
          }
        });
      }
  });

  $('.content-moderation, .manage-users').on('change', '.moderation-filters select, .moderation-filters input[type="checkbox"], .admin-filters select', function(e) {
    $(this).closest('form').find('input[type="submit"]').trigger('click');
  });

  if($('.system-admin-page select[multiple]').length && !$('.system-admin-page select[multiple]').next('.easyselect-container').length) {

    $('.system-admin-page select[multiple]').easySelect({
      removeIcon: '<span></span>'
    });

    $('.content-moderation .easyselect-field').attr('placeholder', 'Search Talents');
    $('.manage-students .easyselect-field').attr('placeholder', 'Search Students');
    $('.manage-administrators .easyselect-field').attr('placeholder', 'Search Administrators');
  }

  $('.manage-users').on('click', '#add-user-modal-trigger', function(e) {
    e.preventDefault();
    $('#add_user_modal').addClass('visible');
    $('input[name="invitation[type]"]').trigger('change');
  });

  $('.modal-overlay').on('change', 'input[name="invitation[type]"]', function() {
    const $modal = $(this).closest('.modal'),
      value = $modal.find('input[name="invitation[type]"]:checked').val();
    $modal.find('.admin-fields').hide();
    $modal.find('.admin-fields input').prop( "disabled", true );
    $modal.find('.new-school').hide();
    $modal.find('.new-school input').prop( "disabled", true ).prop( "required", false );
    $modal.find('.admin-fields.' + value + '-select').show();
    $modal.find('.admin-fields.' + value + '-select input').prop( "disabled", false );
  });

  $('.modal-overlay').on('click', '#add_user_submit, #update_user_submit', function(e) {
    e.preventDefault();
    $('#add_user_modal .error-message').text('');
    $(this).closest('form').find('input[type="submit"]').trigger('click');
  });

  $('.modal-overlay').on('click', '.modal .close, .modal .close-button', function(e) {
    e.preventDefault();
    let len = $('.modal-overlay.visible').length;
    $($('.modal-overlay.visible')[len - 1]).removeClass('visible');
  });

  // $('.manage-users').on('click', '.users-nav a', function(e) {
  //   if($('.users-nav').hasClass('students')) return;
  //   e.preventDefault();
  //   $('.users-nav li').removeClass('current');
  //   $(this).parent().addClass('current');
  //   $('.users-holder').hide();
  //   $('.users-holder.' + $(this).data('screen')).show();
  // });

  $('#system-admin-csv-upload-form input[type="file"]').on('change', function() {
    if($('.upload-csv-modal.emails-csv').length) {

      $('#system-admin-csv-upload-form input[type="submit"]').trigger('click').prop('disabled', true).addClass('disabled');
      $('#system-admin-csv-upload-form .button').addClass('disabled');
      $('#system-admin-csv-upload-form .loading-indicator').css('display', 'inline-block');
      $(this).val('');

    }
    else {

      $('.csv-info-container, .csv-input-container').hide();
      $('.email-text-editor-container').show();
    }

  });

  $('#system-admin-csv-upload-form input[type="submit"]').on('click', function(e) {

    setTimeout(function() {
      $('#system-admin-csv-upload-form input[type="submit"]').prop('disabled', true).addClass('disabled');
      $('#system-admin-csv-upload-form .loading-indicator').css('display', 'inline-block');
    }, 100);

  });
    // $('#system-admin-csv-upload-form input[type="submit"]').trigger('click').prop('disabled', true).addClass('disabled');
    // $('#system-admin-csv-upload-form .button').addClass('disabled');
    // $('#system-admin-csv-upload-form .loading-indicator').css('display', 'inline-block');

  $('.modal-overlay').on('click', '.new-school-prompt a', function(e) {
    e.preventDefault();
    let $form = $(this).closest('form'),
      $new_school = $form.find('.new-school');
    $(this).parent().hide();
    $new_school.show();
    $new_school.find('.mdc-text-field').removeClass('mdc-text-field--disabled')
    $new_school.find('input').prop( "disabled", false ).prop( "required", true );
    $form.find('.admin-fields.school_admin-select').hide();
    $form.find('.admin-fields.school_admin-select input').prop( "disabled", true );
  });

  $('.manage-users').on('click', '#upload-csv-modal-trigger', function(e) {
    e.preventDefault();
    $('#upload_csv_modal').addClass('visible');

  });

  $(document).on('click', '#email-text-modal-trigger', function(e) {
    e.preventDefault();
    $('#edit_email_text_modal').addClass('visible');
    $('.csv-info-container, .csv-input-container').show();
    $('.email-text-editor-container').hide();
  });

  $('#edit_email_text_modal .mdc-select input, #upload_csv_modal .mdc-select input').on('change', function() {
    $('.csv-input-container .actions').show();
    $('#upload_csv_modal .modal').removeClass('bottom-padded');
    if(!$('.upload-csv-modal.emails-csv').length) {
      $.get('/system_admin/manage_students/get_school_email_editor/' + $(this).val());
    }
  });

  $('.modal-overlay, .admin-edit-email').on('click', '#preview-email-invitation', function(e) {
    e.preventDefault();
    let $form = $(this).closest('form');
    $form.attr('action', $(this).data('url'));
    $form.removeAttr('data-remote');
    $form.attr('target', '_blank');
    $form.submit();
    $form.attr('action', $(this).data('default-url'));
    $form.attr('data-remote', 'true');
    $form.removeAttr('target');
  });

  $('.admin-edit-email').on('change', '.send-through-system-radio', function() {
    if($('.send-through-system-radio:checked').val() == '0') {
      $('.date-entry-fields input').prop('disabled', true);
      $('.date-entry-fields').find('.mdc-text-field').addClass('mdc-text-field--disabled');
      $('.email-example-container').show();
    } else {
      if($('.date-entry-fields').data('method') != 'student_invitation') {
        $('.date-entry-fields input').prop('disabled', false)
        $('.date-entry-fields').find('.mdc-text-field').removeClass('mdc-text-field--disabled');
      }
      $('.email-example-container').hide();
    }
    //$('.send-date-entry, .email-content-container, .email-example-container').toggle();
  });

  $('.admin-edit-email').on('click', '#send-email-now', function(e) {
    e.preventDefault();
    $('#send_now').val(true);
    $('.admin-edit-email form').submit();
  });

});
